import { render } from "./LatestWorks.vue?vue&type=template&id=37528ae4"
import script from "./LatestWorks.vue?vue&type=script&lang=js"
export * from "./LatestWorks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__